var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.985,
    height: 105.844,
    viewBox: "0 0 39.985 105.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(0 -1382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    d: "M0,0H33.985a6,6,0,0,1,6,6V99.844a6,6,0,0,1-6,6H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 1382)",
    fill: "#32d172"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(10.584 1396.701)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Filters",
    transform: "translate(14 77.031) rotate(-90)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FILTERS")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(4.116 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M0,0H14.113V14.113H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M12.76,11.82v1.764H11.584V11.82H10.408V10.056h3.528V11.82Zm-9.408,0v1.764H2.176V11.82H1V10.056H4.528V11.82ZM6.88,4.764V3H8.056V4.764H9.232V6.528H5.7V4.764Zm0,2.94H8.056v5.88H6.88ZM2.176,8.88V3H3.352V8.88Zm9.408,0V3H12.76V8.88Z",
    transform: "translate(-0.412 -1.236)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.eb2511ffcb16b46fbb6bf59e9596c955.svg";
export { ForwardRef as ReactComponent };